import { createLazyFileRoute } from "@tanstack/react-router";

import { NewPanelPage } from "@/features/admin/routes/PanelNew";

export const Route = createLazyFileRoute("/_auth/admin/panels/new")({
  component: NewPanelPage,
});
